import type { Invoice } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2, mockCustomers } from './seed'

/**
 * Shared invoice fixture data for the billing domain, cross-referencing
 * real customers from seed.ts via driverID.
 */
export const mockInvoices: Invoice[] = [
  {
    billID: 'bill-1',
    billType: 'service',
    billStatus: 'Draft',
    billedAmount: 1450,
    currency: 'SEK',
    bookedBy: 'Anna Karlsson',
    billComments: 'Winter tire change',
    billingDate: '2025-03-01',
    paymentDays: 30,
    driverID: mockCustomers[0]?.driverID,
    driverFirstName: mockCustomers[0]?.driverFirstName,
    driverLastName: mockCustomers[0]?.driverLastName,
    driverEmail: mockCustomers[0]?.driverEmail,
    driverPhoneNumber: mockCustomers[0]?.driverPhoneNumber,
    driverAddress: mockCustomers[0]?.driverAddress,
    driverZipCode: mockCustomers[0]?.driverZipCode,
    driverAddressCity: mockCustomers[0]?.driverAddressCity,
    driverCountry: mockCustomers[0]?.driverCountry,
    driverHasCard: mockCustomers[0]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-03-01T08:00:00Z',
    updatedAt: '2025-03-01T08:00:00Z',
  },
  {
    billID: 'bill-2',
    billType: 'service',
    billStatus: 'Sent',
    billedAmount: 2350,
    currency: 'SEK',
    bookedBy: 'Johan Berg',
    billComments: 'Brake pad replacement',
    billingDate: '2025-03-05',
    paymentDays: 30,
    driverID: mockCustomers[1]?.driverID,
    driverFirstName: mockCustomers[1]?.driverFirstName,
    driverLastName: mockCustomers[1]?.driverLastName,
    driverEmail: mockCustomers[1]?.driverEmail,
    driverPhoneNumber: mockCustomers[1]?.driverPhoneNumber,
    driverAddress: mockCustomers[1]?.driverAddress,
    driverZipCode: mockCustomers[1]?.driverZipCode,
    driverAddressCity: mockCustomers[1]?.driverAddressCity,
    driverCountry: mockCustomers[1]?.driverCountry,
    driverHasCard: mockCustomers[1]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-03-05T08:00:00Z',
    updatedAt: '2025-03-05T08:00:00Z',
  },
  {
    billID: 'bill-3',
    billType: 'service',
    billStatus: 'Paid',
    billedAmount: 980,
    currency: 'SEK',
    bookedBy: 'Maria Lindqvist',
    billComments: 'Oil change',
    billingDate: '2025-02-20',
    paymentDate: '2025-02-25',
    paymentDays: 30,
    driverID: mockCustomers[2]?.driverID,
    driverFirstName: mockCustomers[2]?.driverFirstName,
    driverLastName: mockCustomers[2]?.driverLastName,
    driverEmail: mockCustomers[2]?.driverEmail,
    driverPhoneNumber: mockCustomers[2]?.driverPhoneNumber,
    driverAddress: mockCustomers[2]?.driverAddress,
    driverZipCode: mockCustomers[2]?.driverZipCode,
    driverAddressCity: mockCustomers[2]?.driverAddressCity,
    driverCountry: mockCustomers[2]?.driverCountry,
    driverHasCard: mockCustomers[2]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    createdAt: '2025-02-20T08:00:00Z',
    updatedAt: '2025-02-25T08:00:00Z',
  },
  {
    billID: 'bill-4',
    billType: 'product',
    billStatus: 'Late',
    billedAmount: 3200,
    currency: 'SEK',
    bookedBy: 'Erik Svensson',
    billComments: 'Full inspection package',
    billingDate: '2025-01-15',
    paymentDays: 30,
    driverID: mockCustomers[3]?.driverID,
    driverFirstName: mockCustomers[3]?.driverFirstName,
    driverLastName: mockCustomers[3]?.driverLastName,
    driverEmail: mockCustomers[3]?.driverEmail,
    driverPhoneNumber: mockCustomers[3]?.driverPhoneNumber,
    driverAddress: mockCustomers[3]?.driverAddress,
    driverZipCode: mockCustomers[3]?.driverZipCode,
    driverAddressCity: mockCustomers[3]?.driverAddressCity,
    driverCountry: mockCustomers[3]?.driverCountry,
    driverHasCard: mockCustomers[3]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    createdAt: '2025-01-15T08:00:00Z',
    updatedAt: '2025-01-15T08:00:00Z',
  },
  {
    billID: 'bill-5',
    billType: 'service',
    billStatus: 'Sent',
    billedAmount: 1750,
    currency: 'SEK',
    bookedBy: 'Sofia Nilsson',
    billComments: 'Wheel alignment',
    billingDate: '2025-03-10',
    paymentDays: 14,
    driverID: mockCustomers[4]?.driverID,
    driverFirstName: mockCustomers[4]?.driverFirstName,
    driverLastName: mockCustomers[4]?.driverLastName,
    driverEmail: mockCustomers[4]?.driverEmail,
    driverPhoneNumber: mockCustomers[4]?.driverPhoneNumber,
    driverAddress: mockCustomers[4]?.driverAddress,
    driverZipCode: mockCustomers[4]?.driverZipCode,
    driverAddressCity: mockCustomers[4]?.driverAddressCity,
    driverCountry: mockCustomers[4]?.driverCountry,
    driverHasCard: mockCustomers[4]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-03-10T08:00:00Z',
    updatedAt: '2025-03-10T08:00:00Z',
  },
  {
    billID: 'bill-6',
    billType: 'service',
    billStatus: 'Paid',
    billedAmount: 4100,
    currency: 'SEK',
    bookedBy: 'Anna Karlsson',
    billComments: 'Seasonal tire storage + change',
    billingDate: '2025-02-01',
    paymentDate: '2025-02-10',
    paymentDays: 30,
    driverID: mockCustomers[5]?.driverID,
    driverFirstName: mockCustomers[5]?.driverFirstName,
    driverLastName: mockCustomers[5]?.driverLastName,
    driverEmail: mockCustomers[5]?.driverEmail,
    driverPhoneNumber: mockCustomers[5]?.driverPhoneNumber,
    driverAddress: mockCustomers[5]?.driverAddress,
    driverZipCode: mockCustomers[5]?.driverZipCode,
    driverAddressCity: mockCustomers[5]?.driverAddressCity,
    driverCountry: mockCustomers[5]?.driverCountry,
    driverHasCard: mockCustomers[5]?.driverHasCard,
    orders: [],
    additionalBillRows: [],
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    createdAt: '2025-02-01T08:00:00Z',
    updatedAt: '2025-02-10T08:00:00Z',
  },
]
